import {useUpmPlant} from '@hconnect/upm'
import {useForm} from 'react-hook-form'

import {useKilns, useRefraModal} from '@refra/modules/common/providers'
import {useAddStaticPart} from '@refra/modules/refra-static-parts/hooks/mutations'
import {AddStaticPartForm} from '@refra/modules/refra-static-parts/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const useAddStaticPartForm = () => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()
  const {closeModal} = useRefraModal()

  const {mutate: addStaticPart, isPending: isAddingStaticPart} = useAddStaticPart({})

  const formMethods = useForm<AddStaticPartForm>({
    defaultValues: {
      name: '',
      type: undefined,
      description: ''
    }
  })

  const onSubmit = formMethods.handleSubmit((values: AddStaticPartForm) => {
    if (values.type !== undefined) {
      addStaticPart(
        {
          plantUpmId: upmPlant.upmId,
          kilnUpmId: selectedKiln.upmId,
          staticPartDTO: {
            type: values.type,
            name: values.name,
            description: values.description
          }
        },
        {onSuccess: () => onClose()}
      )
    }
  })

  const onClose = () => {
    formMethods.reset()
    closeModal()
  }

  return {formMethods, isFormBeingProcessed: isAddingStaticPart, onSubmit, onClose}
}
